var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-section"},[_c('section',{staticClass:"home-page",style:({
      backgroundImage:
        'url(https://cdn.trailfinders.com/lhyeeujtsh_bg-home.jpg)',
    })},[_c('b-container',{staticClass:"main-cont"},[_vm._t("default")],2)],1),_c('LoadingSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }